/**
 * Locations admin page localization (en).
 */
export default {
  title: "Locations",
  subtitle: "Manage physical locations and LIS mappings",
  add: "Add location",
  edit: "Edit",
  delete: "Delete",
  refresh: "Refresh",
  navigate: "Open location",
  add_title: "Add location",
  add_subtitle: "Create a new physical location and LIS mapping",
  subtitle_name: "Location",
  subtitle_id: "Location ID",
  subtitle_lis_id: "Code",
  subtitle_name_tooltip: "Location name",
  subtitle_id_tooltip: "System ID",
  subtitle_lis_id_tooltip: "Instrument ID in LIS iLab",
  edit_title: "Edit location",
  delete_title: "Delete location",
  delete_message: "This location will be removed permanently.",
  delete_has_instruments:
    "This location cannot be deleted because it still has instruments assigned. Please remove or reassign them first.",
  empty: "No locations yet",

  list: {
    status_total: "{count} location | {count} locations",
    status_no_instruments: "No instruments",
    status_with_instruments: "{count} instrument | {count} instruments",
    description: "Locations group instruments by site, ward or department.",
    empty: {
      title: "No locations yet",
      description: "Add your first location to start organising instruments.",
    },
  },

  detail: {
    description: "Instruments installed at this location.",
    delete: "Delete location",
    edit: "Edit location",
    save: "Save Changes",
    reset: "Reset",
    details_tab: "Details",
    instruments: {
      tab: "Instruments",
      empty_title: "No instruments at this location",
      empty_description: "Assign an instrument to this location to see it here.",
    },
    toolbar: {
      refresh_instruments: "Refresh",
      add_instrument: "Add instrument",
    },
  },

  tabs: {
    all: "All locations",
  },

  columns: {
    location: "Location",
    name: "Name",
    mapping_key: "Code",
    mapping_key_tooltip: "External code used to identify this location in connected LIS/HIS systems",
    note: "Note",
    instrument_count: "Instruments",
    actions: "Actions",
  },

  fields: {
    name: "Name",
    name_hint: "Display name shown across the system",
    name_placeholder: "e.g. Lab A, Ward 3, Reception",
    mapping_key: "Mapping key",
    mapping_key_hint: "Instrument ID in LIS iLab",
    mapping_key_placeholder: "e.g. LOC01",
    note: "Note",
    note_hint: "Optional — visible in the location header and tooltips",
    note_placeholder: "e.g. Main blood lab, ground floor",
  },

  validation: {
    name_required: "Name is required",
    name_too_long: "Name must be 100 characters or fewer",
    name_taken: "A location with this name already exists",
    mapping_key_required: "Mapping key is required",
    mapping_key_too_long: "Mapping key must be 100 characters or fewer",
    mapping_key_taken: "A location with this mapping key already exists",
    note_too_long: "Note must be 500 characters or fewer",
  },

  snackbar_added: 'Location "{name}" added',
  snackbar_updated: 'Location "{name}" updated',
  snackbar_deleted: 'Location "{name}" deleted',
  loadFailed: "Failed to load locations",
};
